import React from 'react';
export function Header() {
  return <header className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between px-6 py-6" data-id="element-20">
      <div className="text-white font-manrope font-bold text-2xl tracking-tight" data-id="element-21">
        ROI
      </div>
      <button className="border border-roi-red text-roi-red px-4 py-2 rounded-[8px] text-sm font-semibold hover:bg-roi-red hover:text-white transition-colors" data-id="element-22">
        Book Demo
      </button>
    </header>;
}